const M = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuNTU2IDFMMjMgNy40NDR2OS4xMTJMMTYuNTU2IDIzSDcuNDQ0TDEgMTYuNTU2VjcuNDQ0TDcuNDQ0IDFoOS4xMTJ6bS0uODI4IDJIOC4yNzJMMyA4LjI3MnY3LjQ1Nkw4LjI3MiAyMWg3LjQ1NkwyMSAxNS43MjhWOC4yNzJMMTUuNzI4IDN6TTEyIDE1Ljk5OGExIDEgMCAxIDEgMCAyIDEgMSAwIDAgMSAwLTJ6bTEuMDA0LTEwdjhoLTIuMDAxdi04aDJ6IiAgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+";
export {
  M as default
};
//# sourceMappingURL=danger-75ebdf96.mjs.map
